import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { EscapeHtmlModule } from '@infomaniak/angular-common';
import { TranslocoModule } from '@ngneat/transloco';

import {
  ErrorAlreadyAcceptedComponent,
} from './already-accepted/already-accepted.component';
import { ErrorCanceledComponent } from './canceled/canceled.component';
import { ErrorDeletedComponent } from './deleted/deleted.component';
import { ErrorExpiredComponent } from './expired/expired.component';
import { ErrorGenericComponent } from './generic/generic.component';
import { ErrorNotMatchComponent } from './not-match/not-match.component';
import { ErrorOwnComponent } from './own/own.component';
import { ErrorRequestsComponent } from './requests/requests.component';
import { SignupErrorsComponent } from './signup-errors.component';


@NgModule({
  declarations: [
    SignupErrorsComponent,
    ErrorAlreadyAcceptedComponent,
    ErrorExpiredComponent,
    ErrorCanceledComponent,
    ErrorGenericComponent,
    ErrorNotMatchComponent,
    ErrorOwnComponent,
    ErrorRequestsComponent,
    ErrorDeletedComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    SharedSignupModule,
    MatButtonModule,
    EscapeHtmlModule
  ],
  exports: [
    SignupErrorsComponent,
    ErrorAlreadyAcceptedComponent,
    ErrorExpiredComponent,
    ErrorCanceledComponent,
    ErrorGenericComponent,
    ErrorNotMatchComponent,
    ErrorOwnComponent,
    ErrorRequestsComponent,
    ErrorDeletedComponent
  ]
})
export class SignupErrorsModule { }
